module.exports = __webpack_public_path__ + "img/SendIcon.7df30f21.svg";